import React from 'react';

import { useApexAdminPortalStateContext } from '../../ApexAdminPortalContext';
import View from './View';

const Profiles = () => {
  const { investigationResource } = useApexAdminPortalStateContext();
  const [profiles, setProfiles] = React.useState([]);

  const refreshRows = () => {
    setProfiles(investigationResource?.attr('profiles')?.resources()?.list());
  };
  React.useEffect(() => {
    refreshRows();
  }, [investigationResource]);

  if (!investigationResource) {
    return null;
  }

  return (
    <View
      profiles={profiles}
    />
  );
};

Profiles.propTypes = {};

export default Profiles;
